var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchPinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15l1-2V7.858c1.721-.447 3-2 3-3.858 0-2.206-1.794-4-4-4S6 1.794 6 4c0 1.858 1.279 3.411 3 3.858V13l1 2zM8 4c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.267 8.563l-.533 1.928C16.325 11.207 18 12.584 18 14c0 1.892-3.285 4-8 4s-8-2.108-8-4c0-1.416 1.675-2.793 4.267-3.51l-.533-1.928C2.197 9.54 0 11.623 0 14c0 3.364 4.393 6 10 6s10-2.636 10-6c0-2.377-2.197-4.46-5.733-5.437z",
    fill: "currentColor"
  })));
}

export default SvgSearchPinIcon;